import { useTheme } from 'components/core/theme-provider';
import { cn } from 'lib/utils';

interface WorkingKaomojiProps {
  kaomoji: string;
  className?: string;
  style?: React.CSSProperties;
}

export function WorkingKaomoji({ kaomoji, className, style }: Readonly<WorkingKaomojiProps>) {
  const { theme } = useTheme();

  return (
    <span
      className={cn(
        'working-kaomoji shrink-0 text-sm leading-none',
        theme === 'dark' ? 'text-foreground/80' : 'text-grey-900/80',
        className,
      )}
      style={style}
      aria-hidden
    >
      {kaomoji}
    </span>
  );
}
